import { useEffect } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

export default function ScrollToTop(props: { except: string[] }) {
    const { pathname } = useLocation();

    useEffect(() => {
        for (const exceptPath of props.except) {
            if (matchPath(exceptPath, pathname)) return;
        }
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}
